//Comentario necesario para codificación en UTF-8, ver Inc6743
(function () {
	var App = angular.module('pphhApp');
	App.controller("publicController", [ "$scope", "$window", "$mdDialog",
		function ($scope, $window, $mdDialog) {
	
			$scope.go = function(url) {
				$window.location.href = url;
			}
	
			$scope.currentNavItem = "access";
			$scope.init = function (section) {
				$scope.currentNavItem = section;
			};
	
			$scope.showFull = function () {
				var content =
					'<div>'
					+ '<img src="' + _contextPath + '/static/img/DHs.jpg" width="950" style="border: none;" />'
					+ '</div>'
				var infoDialog = $mdDialog.alert()
					.clickOutsideToClose(true)
					.htmlContent(content)
					.ok(UIMessages.dialog.confirm.cerrar)
					;
	
				$mdDialog.show(infoDialog);
			};
		}
	]);
})();
